import { render, staticRenderFns } from "./DetailsNew.vue?vue&type=template&id=023917cc&scoped=true&"
import script from "./DetailsNew.vue?vue&type=script&lang=js&"
export * from "./DetailsNew.vue?vue&type=script&lang=js&"
import style0 from "./DetailsNew.vue?vue&type=style&index=0&id=023917cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023917cc",
  null
  
)

export default component.exports